<template>
  <div>
    <v-dialog v-model="estadoComp" persistent hide-overlay fullscreen>

      <v-card v-if="!estadoComponente">
        <v-card-title v-if="evento == 'view' || evento == 'view_docente'" class="modal_title py-5 mb-4">
          <v-row class="d-flex justify-space-between">
            {{ formTitle }}


            <v-spacer></v-spacer>
            <v-btn dark small class="btn_style2 mr-3 mt-1" @click="imprimirEvaluacion"> Vista impresión </v-btn>
            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon
                dark>fa-times</v-icon></v-btn>
          </v-row>
          <!--  closeFullScreen(), -->
        </v-card-title>

        <v-card-title v-if="evento == 'evaluate'" class="modal_title py-5 mb-2">
          <v-row class="d-flex justify-space-between">
            <v-col cols="8">
              Estudiante: {{ alumno.ape1_persona }} {{ alumno.ape2_persona }}
              {{ alumno.nombre_persona }}
            </v-col>

            <v-col cols="4" v-if="evento == 'evaluate' && minutos != null " class="text-end">
              <!-- <RelojRegresivo class="pt-4" @expirado="timeOutEvaluacion" :minutos="minutos" :id="confirm.id"></RelojRegresivo> -->
              <RelojRegresivoEval v-if="estadoReloj" @expirado="timeOutEvaluacion" :minutos="minutos" :id="parametros.items.id"
                :estado="estadoReloj"></RelojRegresivoEval>

              <div v-else> 
                <v-spacer></v-spacer>
                <v-btn fab dark x-small class="btn_style3" @click="$emit('close')">
                <v-icon dark>fa-times</v-icon></v-btn>
              </div>
              <!-- closeFullScreen() -->
            </v-col>

          </v-row>
        </v-card-title>

        <v-card-title v-if="evento == 'qualify' || evento == 'qualifyAlumno'" class="modal_title py-5 mb-2">
          <v-row class="d-flex justify-space-between">
            Estudiante: {{ alumno.ape1_persona }} {{ alumno.ape2_persona }}
            {{ alumno.nombre_persona }}
            <v-spacer></v-spacer>

            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-divider></v-divider>

        <div v-show="!ejecutarState" color="#f5f5f5">
          <component :is="compNameIntro" :estadoComp="estadoComponenteIntro" :parametros="parametroCompIntro"
            @click="ejecutarEval">
          </component>
        </div>
          <v-card-text v-show="ejecutarState">
            <v-col class="text-center ma-0" cols="12">
              <v-card v-if="usetitle" outlined class="pa-0 mb-2"
                :style="[{ 'background-color': data.color_fondo_titulo }]">
                <span class="gestor_titulo" v-html="data.titulo"></span>
              </v-card>
              <v-card outlined class="pa-0 mb-4" :style="[{ 'background-color': data.color_fondo_pregunta }]">
                <span class="ma-1 gestor_subtitulo" v-html="data.pregunta"></span>
              </v-card>
              
              <!-- PREGUNTA UNICA RESPUESTA-->
              <template v-if="data.id_tipo_pregunta === 'PU'">
                <v-row>
                  <v-col cols="8">
                    <!-- <v-radio-group :mandatory="false" class="ml-12"> -->
                    <v-radio-group class="mt-0" v-model="respuestaPU" :mandatory="false">
                      <v-alert class="checkmsg-hide" v-for="item of data.respuesta" :key="item.id" dense color="#1565c0"
                        border="left" elevation="2" colored-border>
                        <v-radio :label="item.respuesta" :value="item.id" :disabled="inhabilitar"
                          @change="SelectQuestion(item)"></v-radio>
                      </v-alert>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="4" v-if="viewQuestion">
                    <v-alert dense :type="colorQuestion">
                      <h3>Respuesta: {{ question }}</h3>
                    </v-alert>
                  </v-col>
                </v-row>
              </template>

              <!-- PREGUNTA MULTIPLE OPCIONES -->
              <template v-if="data.id_tipo_pregunta === 'PM'">
                <v-row>
                  <v-col cols="8">
                    <v-alert class="checkmsg-hide" v-for="item of data.respuesta" :key="item.id" dense color="#1565c0"
                      border="left" elevation="2" colored-border>
                      <v-checkbox dense :label="item.respuesta" v-model="respuestaPM" :disabled="inhabilitar"
                        @change="SelectQuestionPM(respuestaPM)" :value="item.id"></v-checkbox>
                    </v-alert>
                  </v-col>

                  <v-col cols v-if="viewQuestion">
                    <v-alert type="info">OPCIONES</v-alert>
                    <ul>
                      <li v-for="item of listPM" :key="item.id">
                        <h3 style="color: #43a047" v-if="item.correcta === true">
                          {{ item.respuesta }}
                          <v-icon color="success" class="ml-2">fa-check</v-icon>
                        </h3>
                        <h3 style="color: #e53935" v-else>
                          {{ item.respuesta }}
                          <v-icon color="error" class="ml-2">fa-times</v-icon>
                        </h3>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
              </template>

              <!--  RESPUESTA VERDADERO O FALSO -->
              <template v-if="data.id_tipo_pregunta === 'PV'">
               
                <v-row>
                  <v-col cols="8">
                    <v-radio-group v-model="respuestaPV" class="mt-0" :mandatory="false">
                      <v-alert class="checkmsg-hide" v-for="item of data.respuesta" :key="item.id" dense color="#1565c0"
                        border="left" elevation="2" colored-border>
                        <v-radio :label="item.respuesta" :value="item.id" :disabled="inhabilitar"
                          @change="SelectQuestion(item)"></v-radio>
                      </v-alert>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="4" v-if="viewQuestion">
                    <v-alert dense :type="colorQuestion">
                      <h3>Respuesta: {{ question }}</h3>
                    </v-alert>
                  </v-col>
                </v-row>
              </template>

              <!--  RESPUESTA PREGUNTA DESARROLLO -->
              <template v-if="data.id_tipo_pregunta === 'PD'">
                <v-row>
                  <v-col cols="12">
                    <div class="alertKW">
                      <v-textarea class="texto" label="Ingrese Respuestas" title="editar" :disabled="inhabilitar"
                        v-model="respuestaPD" @keyup="SelectQuestionPD(respuestaPD)" required>
                      </v-textarea>
                    </div>
                  </v-col>
                </v-row>

                <v-row v-if="evento == 'qualify' || evento == 'qualifyAlumno'">
                  <v-col cols="6">
                    <v-textarea class="texto" label="Observación" title="editar" :disabled="inhabilitarAlumno"
                      v-model="calificar.observacion_docente" outlined auto-grow rows="2" prepend-icon="border-color"
                      required>
                    </v-textarea>
                  </v-col>
                  <!-- id respuesta criterio docente  segun respuesta del alumno -->
                  <v-col cols="4">
                    <v-select label="Calificar Pregunta:" v-model="calificar.id_calificacion"
                      :disabled="inhabilitarAlumno" :items="listCalificacion" item-value="id" item-text="calificacion">
                    </v-select>
                  </v-col>

                  <v-col cols="2" v-if="evento == 'qualify'">
                    <v-btn class="btn_block_style2" small @click="SaveCalificarPregAlumno()">Guardar</v-btn>
                  </v-col>
                </v-row>
              </template>
              <!--  END RESPUESTA PREGUNTA DESARROLLO -->
            </v-col>
          </v-card-text>

          <!--  BUTOON NEX AND BACK   -->
          <v-card-actions v-show="ejecutarState">
            <v-row>
              <v-col cols="12" md="12" lg="12" class="d-flex justify-center align-center">
                <v-chip color="blue" class="texto_white" label>
                  Preguntas: {{ indexPreg + 1 }} / {{ cantidadPreg }}
                </v-chip>
              </v-col>
              <v-col cols="6" md="12" lg="12" class="d-flex justify-center align-center">
                <v-btn class="btn_block_style2 mx-13" small @click="PagBack()" :disabled="indexPreg == 0">Anterior</v-btn>

                <v-progress-linear :value="progressEval" rounded height="20">
                  <strong>{{ Math.ceil(progressEval) }}%</strong>
                </v-progress-linear>
                <v-btn class="btn_block_style2 mx-13" small @click="PagNext()" :disabled="indexPreg + 1 == cantidadPreg">
                  Siguiente
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-card-actions v-show="ejecutarState">
            <v-row v-if="evento == 'evaluate'">
              <v-col cols="6" md="12" lg="12" class="d-flex justify-center align-center mt-13">
                <v-btn class="btn_block_style2" small @click="ConfirmItem()">Finalizar Evaluación</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
      </v-card>
      <v-card v-else>
        <component :is="compName" :estado="estadoComponente" :parametros="parametroComp"
          @close="estadoComponente = false">
        </component>
      </v-card>
    </v-dialog>
    <!-- fin evaluacion consulta -->
    <!--  DIALOGO TIEMPO FUERA  -->
    <v-dialog v-model="dialogMensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="modal_title py-5 mb-4"> </v-card-title>
        <v-card-text> Termino su tiempo de evaluación</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_block_style2" small @click="
      dialogMensaje = false;
    ">Aceptar</v-btn>
          <!-- this.$emit('close');  REDUNDA PARECE  -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm @aceptar="SaveItem" @cancelar="Cancelar" :title="confirm.title" :active="confirm.active" :loading="isLoading" />
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import RelojRegresivo from "./relojRegresivo.vue";
import imprimirEval from "./imprimirEval.vue";

import RelojRegresivoEval from "../../Academico/Alumno/components/RelojCaducaSomosHabiles.vue";
import introExamenTemplate from "../../../components/introExamenTemplate.vue";

export default {
  name: "VisorEvaluacion",
  components: { RelojRegresivo, imprimirEval, RelojRegresivoEval, introExamenTemplate },
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  data: () => ({
    rutaservidor: API_URL,
    paramComponente: { id_modulo: 8, id_submodulo: 94 }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario
    test: false,
    evento: null,
    inhabilitar: false,
    inhabilitarAlumno: false,
    usetitle: false,

    isLoading: false,

    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    dialogMensaje: false,
    data: [],

    formTitle: "Evaluación",
    preguntaEval: [],
    progressEval: 0,

    indexPreg: 0,
    cantidadPreg: 0,

    evaluacion: {},
    alumno: {},

    respuestaPU: "",
    respuestaPM: [],
    respuestaPV: "",
    respuestaPD: "",
    respuestaAlumno: [],
    observacionDoc: "",
    listCalificacion: [],
    calificar: {},
    calificando: false,
    viewQuestion: true,
    colorQuestion: "",
    question: "",
    listPM: [],
    compName: null,
    estadoComponente: false,
    parametroComp: [],

    ejecutarState: false,

    minutos: null,
    estadoReloj: false,

    compNameIntro: null,
    estadoComponenteIntro: false,
    parametroCompIntro: {}

  }),
  //computadas
  computed: {
    ...mapGetters({
      componenteEvento: "login/componenteEvento",
    }),
    ...mapState({
      listaPreguntasArray: (state) => state.gestEvaluacion.listaPreguntasArray,
    }),
  },
  watch: {
    estadoComp() {
      if (this.estadoComp) {
        this.LoadMain();
        // this.closeFullScreen();
      } else {
        // this.PagNext()
        this.LimpiarForm();
        this.closeFullScreen();
      }
    },
  },
  /*
    mounted() {
        this.LoadMain()
    }, */
  created() {
    this.LoadMain();
    this.actualizarParamentro();
  },
  methods: {
    ...mapActions({
      parametroComponente: "login/parametroComponente",
    }),
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens",
    }),
    /** 
     __________________________
    |  MÉTODO CARGA INICIAL  */
    async LoadMain() {
      // this.openFullScreen();
      this.toggleFullScreen();
      this.ejecutarState = true;
      this.indexPreg = 0;
      this.evento = this.parametros.evento;
    
      await this.GetPreguntaEvaluacion(
        this.parametros.items.id_evaluacion,
        this.parametros.evento
      );

      if (this.evento == "evaluate") {

        this.calificando = false;
        this.minutos = parseInt(this.parametros.items.duracion_evaluacion);
        this.GetAlumnoEvaluacion(this.parametros.items.id_evaluacion, this.parametros.items.id_alumno);

        if (this.parametros.items.fecha_modificada) { 
          this.ejecutarEval();
        }else{
          this.callComponenteIntro();
        }
      }

      if (this.evento == "qualifyAlumno") {
        this.calificando = false;
        await this.GetEvaluationResponse(
          this.parametros.items.id_evaluacion,
          this.parametros.items.id_alumno
        );
        await this.GetAlumnoEvaluacion(
          this.parametros.items.id_evaluacion,
          this.parametros.items.id_alumno
        );
        this.LoadQuestion(this.indexPreg);
        this.inhabilitar = true;
        this.inhabilitarAlumno = true;
      }

      if (this.evento == "qualify") {
        this.calificando = true; //cuando el doc va a calificar envia el estado de 'calificando' para obtener toda la escala evaluativa

        await this.GetEvaluationResponse(
          this.parametros.items.id_evaluacion,
          this.parametros.items.id_alumno
        );
        this.GetAlumnoEvaluacion(
          this.parametros.items.id_evaluacion,
          this.parametros.items.id_alumno
        );
        this.LoadQuestion(this.indexPreg);
        this.inhabilitar = true;
        this.inhabilitarAlumno = false;
      }

      if ( this.evento == "view" && isNaN(this.parametros.items.id_alumno) == false ) {
        this.calificando = false;
        this.GetEvaluationResponse(
          this.parametros.items.id_evaluacion,
          this.parametros.items.id_alumno
        );
      }
    },
    /** 
     ___________________________________
    |  MÉTODO FULLSCREEN O REVERSA    */
    toggleFullScreen() {     
        if (document.fullscreenElement) {
            document.exitFullscreen()
                .catch(err => console.error("Failed to exit fullscreen:", err));
        } else {          
            document.documentElement.requestFullscreen()
                .catch(err => console.error("Failed to enter fullscreen:", err));
        }
    },
    /** 
     ____________________________________
    |  MÉTODO USAR PERMISOS DE PERFIL  */
    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    /** 
     _________________________________________________________
    |          MÉTODO MOSTRAR INTRODUCCION DE TEST          */
    callComponenteIntro() {

      this.ejecutarState = false;

      // CONVERSION DE DATOS:
      // const isoDate = this.parametros.items.fecha_creacion;
      // const dateObj = new Date(isoDate);

      // const options = {
      //   weekday: 'long', // Nombre completo del día de la semana
      //   day: 'numeric', // Día del mes
      //   month: 'long', // Nombre completo del mes
      //   year: 'numeric' // Año en formato numérico completo
      // };

      // const formattedDate = dateObj.toLocaleDateString('es-ES', options);
      // const dateText = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
      // const dateText= '';

      this.compNameIntro = 'introExamenTemplate';
      this.estadoComponenteIntro = true;
      this.parametroCompIntro = {
        titulo: `EVALUACIÓN`,
        subtitulo: 'Evaluación no calificada',
        contenidoCuerpo: [
          { text: 'Fecha limite', subtext: `Hoy a las 23:59 p.m`, icon: 'mdi-calendar' },
          { text: 'Intentos permitidos', subtext: 'Tendrás permitido <strong> 1 intento </strong> para desarrollar tu somos hábiles.', icon: 'mdi-cached' },
          { text: `Duración: ${this.parametros.items.duracion_evaluacion} min`, subtext: 'Una vez finalizado el tiempo tus respuestas quedaran registradas en el sistema.', icon: 'mdi-clock' },
        ],
        contenidoAdicional: [
          // { text: 'Total de preguntas <strong style="font-size: 20px;"> 6 </strong>', icon: 'mdi-cube-outline' },
          { text: 'Revisa que tu conexión a internet sea estable antes de empezar', icon: 'mdi-wifi' },
          { text: `Una vez iniciado el test el cronometro seguira corriendo (${this.parametros.items.duracion_evaluacion} minuto(s)) aunque cierres y vuelvas a reiniciar la pagina.`, icon: 'mdi-alert-octagon' },
          // { text: 'Se recomienda repasar la clase antes de iniciar el test de los somos hábiles', icon: 'mdi-comment-alert' },

        ],
      };
    },

    /** 
     ____________________________________________________
    |  MÉTODO FINALIZACION DE TIEMPO EN LA EVALUACION  */
    // eslint-disable-next-line no-unused-vars
    timeOutEvaluacion(id) {

      this.setEnviarMens({
        tipo: "W",
        mensaje: `Termino su tiempo de la evaluación`,
        tiempo: 4000,
      });
      this.dialogMensaje = true;
      if (this.evento == "evaluate") {
        this.SaveItem();
      }
    },

    imprimirEvaluacion() {
      this.compName = 'imprimirEval';
      this.estadoComponente = true;
    },
    /** 
     _________________________________________________________
    |          MÉTODO EJECUTAR EXAMEN SOMOS HÁBILES         */
    ejecutarEval(){
  
      const ideval = this.parametros.items.id;
      const fecha_modificada = this.parametros.items.fecha_modificada;

      this.ejecutarState = true;
      this.estadoReloj = true;
      this.minutos = this.parametros.items.tiempo_en_uso;

      if (!fecha_modificada) {
        this.actualizarFechaInicioEval(ideval,this.parametros.items.duracion_evaluacion);
      }
    },


  /** 
     ____________________________________________________
    |          MÉTODO CREAR FECHA INICIO SHab          */
    async actualizarFechaInicioEval(id, duracion){      

      try {

        await axios.get(`/evaluacion/alumnos/actualzarfecusmod/${id}/${duracion}`)
     
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },

 

    /** 
     ____________________________________________
    |  MÉTODO OBTENER PREGUNTAS DE EVALUACION  */
    async GetPreguntaEvaluacion(idEvaluacion, evento) {
      let idPreguntaArray = [];
      this.listaPreguntasArray.forEach((element) => {
        idPreguntaArray.push(element.id);
      });

      try {
        let response;

        switch (evento) {
          case "evaluate":
          case "view_docente":
          case "qualify":
          case "qualifyAlumno":
            response = await axios.get(
              `/evaluacion/pregunta/viewVisorEvaluacion/${idEvaluacion}`
            );
            this.parametroComp = response.data
            break;

          case "view":
            response = await axios.post(
              `/evaluacion/pregunta/viewPreguntaVisor`,
              idPreguntaArray
            );
            this.parametroComp = response.data
            break;
        }
        if (response.data.length == 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `No se encontrarón registros`,
            tiempo: null,
          });
          this.preguntaEval = [];
        } else {

          this.preguntaEval = response.data;
          this.LoadQuestion(0);
        }
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },
    /** 
     __________________________________________
    |  MÉTODO CARGAR PREGUNTAS SELECCIONADA  */
    LoadQuestion(index) {
      this.respuestaPU = "";
      this.respuestaPM = [];
      this.respuestaPV = "";
      this.respuestaPD = "";
      this.colorQuestion = "";
      this.question = "";
      this.viewQuestion = false;

      this.calificar.id_calificacion = -1;
      this.calificar.observacion_docente = "";
      this.calificar.respuesta_correcta = false;

      this.data = this.preguntaEval[index];
      if (this.data.titulo == '<span style="font-size:36px">Ingrese un titulo</span>') {
        this.usetitle = false
      } else {
        this.usetitle = true
      }
      this.cantidadPreg = this.preguntaEval.length;
      this.progressEval = (
        (100 * (parseInt(index) + 1)) /
        this.cantidadPreg
      ).toFixed();
      this.SelectPreviewQuestion(
        this.data.id_banco_pregunta,
        this.data.id_tipo_pregunta
      );
    },
    /** 
     ___________________________________________
    |  MÉTODO CARGAR RESPUESTAS SELECCIONADA  */
    async GetEvaluationResponse(id_evaluacion, id_alumno) {
      try {

        let params = { id_evaluacion, id_alumno };

        let response = await axios.post(
          `/evaluacion/alumnosEvaluacion/respuesta`,
          { filter: params }
        );
        let data = response.data;

        if (data.length > 0) {
          // this.respuestaAlumno = data
          const dataNew = data.map(function (obj) {
            if (obj.id_tipo_pregunta == "PM") {
              let arr = obj.respuesta_alumno.split(",");
              let arrNumber = arr.map(Number);
              obj.respuesta_alumno = arrNumber;
            }
            return obj;
          });
          {
            this.respuestaAlumno;
          }
          this.respuestaAlumno = dataNew;
        }
  
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
      //
    },
    /** 
     ___________________________________________
    |  MÉTODO SELECCIONAR SIGUIENTE PREGUNTAS */
    SelectPreviewQuestion(id_pregunta, tipo_pregunta) {
      let finQuestion = {};
      finQuestion = this.respuestaAlumno.find(
        (x) => x.id_banco_pregunta === id_pregunta
      );

      if (finQuestion) {
        if (this.evento == "qualifyAlumno" || this.evento == "qualify") {
          this.ViewQuestion(finQuestion);
        }

        switch (tipo_pregunta) {
          case "PU":
            this.respuestaPU = finQuestion.id_respuesta;
            break;
          case "PV":
            this.respuestaPV = finQuestion.id_respuesta;
            break;
          case "PM":
            this.respuestaPM = finQuestion.respuesta_alumno;
            break;
          case "PD":
            this.respuestaPD = finQuestion.respuesta_alumno;
            this.calificar.respuesta_alumno = finQuestion.respuesta_alumno;
            this.calificar.id_calificacion = finQuestion.id_respuesta;
            this.calificar.observacion_docente = finQuestion.observacion_docente
              ? finQuestion.observacion_docente
              : "";
            break;
          default:
        }
      }
    },
    /** 
     ________________________
    |  MÉTODO VER PREGUNTA */
    ViewQuestion(item) {
      // SELECT correcta FROM ck1_eval_banco_respuestas WHERE id_banco_pregunta = 26 AND id = 160
      this.viewQuestion = true;
      if (item.id_tipo_pregunta == "PV" || item.id_tipo_pregunta == "PU") {
        if (item.respuesta_correcta === true) {
          this.question = "Correcta";
          this.colorQuestion = "success";
        }

        if (item.respuesta_correcta === false) {
          this.question = "Incorrecta";
          this.colorQuestion = "error";
        }
      }

      if (item.id_tipo_pregunta == "PM") {
        this.LoadAnswerPM(item.id_banco_pregunta);
      }
    },

    async LoadAnswerPM(id_pregunta) {
      // this.setEnviarMens({tipo:"W", mensaje: `Get Respuesta : ${id_pregunta}`, tiempo:null})
      try {
        let response = await axios.get(
          `/evaluacion/bancoPregunta/getRepuesta/${id_pregunta}`
        );
        this.listPM = response.data;
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },

    async GetAlumnoEvaluacion(idEvaluacion, idAlumno) {
      try {
        let response = await axios.get(
          `/evaluacion/alumnos/evaluar/alumno/${idAlumno}/evaluacion/${idEvaluacion}`
        );
        let data = response.data;
        if (data.length == 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `No se encontrarón registros`,
            tiempo: null,
          });
          this.preguntaEval = [];
        } else {
          this.evaluacion = data.evaluacion;
          this.alumno = data.alumno;
          if (this.evento == "qualify" || this.evento == "qualifyAlumno") {
            this.GetEscalaEvaluativa();
          }
        }
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },

    async GetEscalaEvaluativa() {
      try {
        let params = {
          id_colegio: this.evaluacion.id_colegio,
          id_ano_lectivo: this.evaluacion.id_ano_lectivo,
          id_nivel: this.evaluacion.id_nivel,
          id_grado: this.evaluacion.id_grado,
          calificar: this.calificando,
        };
        let response = await axios.post(
          `/evaluacion/programacion/escalaEvaluativaGrado/`,
          { filter: params }
        );

        if (response.data.escalaEvaluacion.length == 0) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `No se configuro la escala evaluativa para el grado`,
            tiempo: 8000,
          });
        }
        this.listCalificacion = response.data.notaEvaluacion;
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },

    PagNext() {
      this.indexPreg = this.indexPreg + 1;
      this.LoadQuestion(this.indexPreg);
    },

    PagBack() {
      this.indexPreg = this.indexPreg - 1;
      this.LoadQuestion(this.indexPreg);
    },

    ///////////////////////////////////////////////////
    //-- Componente de  Configuracion de colegio  -----
    ///////////////////////////////////////////////////

    SelectQuestion(item) {
      let respuesta = {
        id_banco_pregunta: item.id_banco_pregunta,
        id_respuesta: item.id,
        respuesta_alumno: item.respuesta,
      };

      let index = this.respuestaAlumno.findIndex(
        (x) => x.id_banco_pregunta === item.id_banco_pregunta
      );

      if (index == -1) {
        this.respuestaAlumno.push(respuesta);
      } else {
        this.respuestaAlumno[index].id_pregunta = respuesta.id_pregunta;
        this.respuestaAlumno[index].id_respuesta = respuesta.id_respuesta;
        this.respuestaAlumno[index].respuesta_alumno =
          respuesta.respuesta_alumno;
      }
    },

    SelectQuestionPD(valor) {
      // let respuesta = { id_banco_pregunta: this.data.id_banco_pregunta, id_respuesta:this.data.respuesta[0].id, respuesta_alumno: valor }
      let respuesta = {
        id_banco_pregunta: this.data.id_banco_pregunta,
        id_respuesta: -1,
        respuesta_alumno: valor,
      };
      let index = this.respuestaAlumno.findIndex(
        (x) => x.id_banco_pregunta === this.data.id_banco_pregunta
      );

      if (index == -1) {
        this.respuestaAlumno.push(respuesta);
      } else {
        this.respuestaAlumno[index].id_pregunta = respuesta.id_pregunta;
        this.respuestaAlumno[index].id_respuesta = respuesta.id_respuesta;
        this.respuestaAlumno[index].respuesta_alumno =
          respuesta.respuesta_alumno;
      }
    },

    SelectQuestionPM(valor) {
      let respuesta = {
        id_banco_pregunta: this.data.id_banco_pregunta,
        id_respuesta: -1,
        respuesta_alumno: valor,
      };
      let index = this.respuestaAlumno.findIndex(
        (x) => x.id_banco_pregunta === this.data.id_banco_pregunta
      );

      if (index == -1) {
        this.respuestaAlumno.push(respuesta);
      } else {
        this.respuestaAlumno[index].id_pregunta = respuesta.id_pregunta;
        this.respuestaAlumno[index].id_respuesta = respuesta.id_respuesta;
        this.respuestaAlumno[index].respuesta_alumno =
          respuesta.respuesta_alumno;
      }
    },

    async ConfirmItem(id) {
      if (this.respuestaAlumno.length == 0) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No ha respondido ninguna respuestas para la evaluación`,
          tiempo: null,
        });
      } else {
        this.confirm.active = true;
        this.confirm.title = `La evaluación se cerrará, una vez finalizada no podrá cambiar sus respuestas.`;
        this.confirm.id = id;
      }
    },

    async SaveItem() {
      try{
        this.isLoading = true;
      let res = {};
      let params = {
        datos: this.parametros.items,
        respuestaAlumno: this.respuestaAlumno,
      };

      if (this.evento == "evaluate") {
        res = await axios.post("/evaluacion/alumnosEvaluacion/", params);
      }

      if (this.evento == "edit") {
        res = await axios.put(
          "/evaluacion/alumnosEvaluacion/" + this.datosEval.id,
          this.datosEval
        );
      }

      if (res.data.messageT == "S") {

        this.estadoReloj = false;
        this.estadoComponenteIntro = false;


        this.clear_confirm();
        this.LimpiarForm();
        this.isLoading = false;
        this.$emit("close");
      }

      this.setEnviarMens({
        tipo: res.data.messageT,
        mensaje: res.data.message,
        tiempo: null,
      });
     
      }catch(error){
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
      
    },

    async SaveCalificarPregAlumno() {
      if (
        this.calificar.id_calificacion == "" ||
        this.calificar.id_calificacion == -1
      ) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: "Debe de ingresar una calificación para la pregunta",
          tiempo: null,
        });
        return false;
      }

      // if(this.calificar.observacion_docente == '' || this.calificar.observacion_docente == null ){
      //     this.setEnviarMens({tipo: "W", mensaje: "Debe de ingresar una observación", tiempo:null})
      //     return false
      // }

      let datos = {
        id: this.parametros.items.id,
        id_evaluacion_alumno: this.parametros.items.id,
        id_evaluacion: this.data.id_evaluacion,
        id_alumno: this.parametros.items.id_alumno,
        id_banco_pregunta: this.data.id_banco_pregunta,
      };

      this.calificar.respuesta_alumno = this.respuestaPD;
      let params = { datos, calificar: this.calificar };
      let res = await axios.post(
        "/evaluacion/alumnosEvaluacion/calificarPregAlumno/",
        params
      );
      this.GetEvaluationResponse(
        this.parametros.items.id_evaluacion,
        this.parametros.items.id_alumno
      );
      if (res.data) {
        this.setEnviarMens({
          tipo: res.data.messageT,
          mensaje: res.data.message,
          tiempo: null,
        });
      }
    },

    Cancelar() {
      this.clear_confirm();
    },

    clear_confirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },

    LimpiarForm() {
      this.respuestaAlumno = [];
      this.indexPreg = -1;
      this.inhabilitar = false;
      this.inhabilitarAlumno = false;
      this.calificar = {
        id_calificacion: "",
        observacion_docente: "",
        respuesta_correcta: false,
        respuesta_alumno: "",
      };
      this.estadoReloj = false;
      // this.minutos = null;
    },

    openFullScreen() {
      var docElm = document.documentElement;
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.msRequestFullscreen) {
        docElm = document.body; //overwrite the element (for IE)
        docElm.msRequestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      }
    },

    closeFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    },
  },
};
</script>

<style scoped>
.texto_white {
  font-size: 14px;
  font-weight: bold;
  color: #fff !important;
}

.texto {
  font-size: 22px !important;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for <2.1.8 */
  {
  transform: translateX(10px);
  opacity: 0;
}

.alertKW {
  border-style: solid;
  border-width: 0, 0, 0, 4px;

  background-color: #fff;
  border: 0px;
  border-left: 8px solid #1565c0;
  box-shadow: 1px 2px 4px 0px #888888;

  font-size: 16px;
  margin-bottom: 16px;
  padding: 8px;
  border-radius: 5px;
}
</style>
<style>
.checkmsg-hide .v-messages.theme--light {
  display: none !important;
}
</style>